<template>
  <div>
    <el-card>
      <el-row :gutter="20">
        <el-col :md="8">
          <select-deduction :disable="false" :deduct="deduction" @setDeduction="changeDeduction(deduction_id = $event)"/>
        </el-col>
        <!--el-col v-if="deduction_id" :md="4">
          <el-select v-model="tenure" placeholder="Sort by" @change="changeDeduction">
            <el-option
              v-for="item in appointStatus"
              :key="item.id"
              :label="item.label"
              :value="item.id"/>
          </el-select>
        </el-col-->
        <el-col v-if="deduction_id" :md="6">
          <span><el-input v-debounce="changeDeduction" :debounce-events="'keydown'" v-model="search" type="text" placeholder="search personnel by lastname" ><i slot="suffix" class="el-input__icon el-icon-search"/></el-input></span>
        </el-col>
        <el-col v-if="deduction_id" :md="4">
          <el-button type="primary" @click="download">
            <i class="el-icon-document-delete"/> Generate Excel
          </el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <span class="notes">
            Below are the list of personnel that have Deduction
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :md="12">
          <div v-if="deduction_id">
            <el-table
              v-loading="loading"
              :data="deduction_data"
              style="width: 100%"
              size="small"
            >
              <el-table-column
                prop="fullname"
                label="Personnel Name"
                width="180"/>
              <el-table-column
                prop="deduction_code"
                label="Deduction Code"
                width="150"/>
              <el-table-column
                prop="amount"
                label="Amount"
                width="120"/>
              <el-table-column
                class-name="deduct-status"
                prop="amount"
                label="Status"
                width="120">
                <template slot-scope="scope">
                  <el-alert
                    :closable="false"
                    :title="(scope.row.active) ? 'Active' : 'In-active'"
                    :type="(scope.row.active === 1) ? 'success' : 'error' "
                    center
                    size="small"/>
                </template>
              </el-table-column>
              <el-table-column
                label="Action">
                <template slot-scope="scope">
                  <el-button type="warning" @click="edit(scope.row)">
                    <i class="el-icon-edit"/>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="text-align: center;">
              <el-pagination :page-size="meta.per_page" :pager-count="7" :total="meta.total" :current-page.sync="meta.page" layout="total, prev, pager, next" @current-change="getEmpDeduction"/>
            </div>
          </div>
          <div v-else>
            <el-row>
              <el-col>
                <div style="text-align: center; margin: 20pt 20pt 20pt 20pt">
                  <i class="el-icon-info" style="color: #0a8700; font-size: 50px"/><br>
                  <span style="color: #0a8700; ">
                    Please select deduction
                  </span>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :md="12">
          <div v-if="selected">
            <el-row>
              <el-col>
                <div class="info-box">
                  <span class="info-title">
                    Personnel Deduction Details
                  </span>
                  <table style="width: 100%" >
                    <tr>
                      <td class="info-lable">
                        Fullname
                      </td>
                      <td class="info-details" colspan="2">
                        : {{ selected.fullname }}
                      </td>
                    </tr>
                    <tr>
                      <td class="info-lable">
                        Deduction Code
                      </td>
                      <td class="info-details" colspan="2">
                        : {{ selected.deduction_code }}
                      </td>
                    </tr>
                    <tr>
                      <td class="info-lable">
                        Status
                      </td>
                      <td class="info-details">
                        <div >
                          <el-switch
                            v-model="deduction_active"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="Active"
                            inactive-text="In-active"
                            @change="update_status"
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="info-lable">
                        Amount
                      </td>
                      <td class="info-details">
                        <el-input
                          v-model="amount "
                          :disabled="!info_edit_dialog"
                          placeholder="Please input"
                        />
                      </td>
                      <td style="text-align: right">
                        <el-button v-show="!info_edit_dialog" type="warning" icon="el-icon-edit" circle size="small" @click="edit_info('edit')"/>
                        <span v-show="info_edit_dialog">
                          <el-button type="success" icon="el-icon-check" circle size="small" @click="save_amount()"/>
                          <el-button type="danger" icon="el-icon-close" circle size="small" @click="edit_info('exit')"/>
                        </span>
                      </td>
                    </tr>
                  </table>
                </div>
              </el-col>
            </el-row>
            <el-row v-if="deduction_id === 56">
              <el-col>
                <div class="info-box">
                  <span class="info-title">
                    Monthly Deduction of withholding tax compensation
                  </span>
                  <el-table
                    :data="taxTableData"
                    style="width: 100%">
                    <el-table-column
                      label="Month">
                      <template slot-scope="scope">
                        <span style="font-weight: lighter !important;">{{ monthList[(scope.row.month - 1)] }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="Amount">
                      <template slot-scope="scope">
                        <span>{{ Number(scope.row.amount).toLocaleString(undefined, {minimumFractionDigits: 2}) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column>
                      <template slot-scope="scope">
                        <el-button type="warning" icon="el-icon-edit" circle size="small" @click="editWamount(scope.row)"/>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <div>
      <el-dialog
        :visible.sync="WamountEnable"
        title="Update With Holding Tax"
        width="30%"
        center>
        <div>
          <el-form model="form" label-width="100px">
            <el-form-item label="amount" >
              <el-input v-model="Wamount"/>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="exitWamount">Cancel</el-button>
          <el-button type="primary" @click="save_Wamount">Confirm</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import SelectDeduction from '../../../layout/components/SelectDeduction'
import { EmpDeduction } from '../../../../api/payroll/empdeduction'
import { NotifySuccess } from '../../../../helper/Helper'
import { getToken } from '@/utils/auth'

export default {
  name: 'DeductionView',
  components: { SelectDeduction },
  data() {
    return {
      tenure: parseInt(this.$store.getters.APStatus),
      appointStatus: [
        { label: 'Permanent', id: null },
        { label: 'Contractual', id: 2 },
        { label: 'Casual', id: 1 }
      ],
      search: null,
      base_url: this.$store.getters.base_url,
      WamountID: null,
      WamountEnable: false,
      Wamount: 0,
      deduction: {},
      loading: false,
      deduction_id: null,
      deduction_data: [],
      deduction_active: true,
      form: [],
      amount: null,
      info_edit_dialog: false,
      info_option: null,
      meta: {
        page: 1
      },
      selected: null,
      taxTableData: [],
      year: new Date().getFullYear(),
      selectedPID: null,
      monthList: [
        'JANUARY',
        'FEBRUARY',
        'MARCH',
        'APRIL',
        'MAY',
        'JUNE',
        'JULY',
        'AUGUST',
        'SEPTEMBER',
        'OCTOBER',
        'NOVEMBER',
        'DECEMBER'
      ],
      campus_id: this.$store.getters.user.currentUser.personnel.department.campus_id
    }
  },
  created() {
    this.$store.dispatch('APStatus', this.$store.getters.APStatus)
  },
  methods: {
    changeDeduction() {
      this.loading = true
      this.getEmpDeduction()
    },
    getEmpDeduction() {
      EmpDeduction({ deduction_view: this.deduction_id, page: this.meta.page, personnel_id: this.search, tenure: this.tenure, campus_id: this.campus_id }, 'get').then(res => {
        this.deduction_data = res.data.empdeduction
        this.meta = res.data.meta
        this.loading = false
      }).catch()
    },
    getTaxTableData(pid) {
      this.WamountEnable = false
      EmpDeduction({ year: this.year, pid: pid }, 'get', 'getMonthlyTax').then(res => {
        // console.log(res.data)
        this.taxTableData = res.data
      }).catch()
    },
    save_Wamount() {
      EmpDeduction({ year: this.year, pid: this.WamountID, amount: this.Wamount }, 'get', 'UpdateWithHoldingPerPersonnel').then(res => {
        NotifySuccess('With Holding Tax Successfully Updated!')
        this.edit(this.selectedPID)
      }).catch()
    },
    editWamount(row) {
      this.WamountID = row.id
      this.WamountEnable = true
      this.Wamount = row.amount
    },
    exitWamount() {
      this.WamountEnable = false
      this.Wamount = 0
    },
    edit(row) {
      this.selectedPID = row
      this.selected = row
      this.amount = row.amount
      this.deduction_active = !!(row.active)
      if (this.deduction_id === 56) {
        this.getTaxTableData(row.personnel_id)
      }
    },
    update_status() {
      EmpDeduction({ id: this.selected.deduct_hearder_id, status: this.deduction_active }, 'post', 'set-active').then(res => {
        if (this.deduction_active) {
          this.$message({ message: 'Activated.', type: 'success' })
        } else {
          this.$message({ message: 'Deactivated.', type: 'warning' })
        }
        this.getEmpDeduction()
      }).catch(error => {
        console.log(error)
      })
    },
    edit_info(data) {
      this.info_option = data
      this.info_edit_dialog = (data === 'edit')
    },
    save_amount() {
      // console.log(this.selected)
      EmpDeduction({ id: this.selected.deduct_details_id, amount: this.amount }, 'post', 'update-amount').then(res => {
        if (res.data.status === 'success') {
          NotifySuccess('Deduction is Successfully Updated!')
          this.info_edit_dialog = false
        }
        this.getEmpDeduction()
      }).catch(error => {
        console.log(error)
      })
    },
    download() {
      this.url = this.base_url + '/payroll/print_deduction?deduction=' + this.deduction_id + '&tenure=' + this.tenure + '&campus=' + this.campus_id + '&token=' + getToken()
      window.open(this.url, '_blank')
    }
  }
}
</script>

<style lang="scss">
  .deduct-status {
    text-align: center !important;
  }
</style>
